/**
 * Given a checkbox `change` event, either reveal or hide a specific
 * target element.
 *
 * @param {Event} event
 */
function revealByCheckbox(event) {
	const revealId = event.target.dataset.revealTargetId;

	if (!revealId) {
		return;
	}

	const revealElement = this.currentStepElement.querySelector(`#${revealId}`);

	if (!revealElement) {
		return;
	}

	if (event.target.checked) {
		revealElement.classList.remove('js-hide', 'invisible');

		for (let inputElement of revealElement.querySelectorAll('input')) {
			inputElement.disabled = false;
		}

		console.log('Checkbox revealed and enabled element:', revealElement);
	} else {
		revealElement.classList.add('js-hide', 'invisible');

		for (let inputElement of revealElement.querySelectorAll('input')) {
			inputElement.disabled = true;
		}

		console.log('Checkbox hid and disabled element:', revealElement);
	}
}

export {
	revealByCheckbox
}